import { CARD_TYPES } from '@zola-helpers/client/dist/es/crossSell/types';
import UniversalCrossSellPreview from '@zola/zola-ui/src/components/UniversalCrossSellPreview';
import useGetCrossSellData from '@zola/zola-ui/src/components/UniversalCrossSellPreview/hooks/useGetCrossSellData';

import _isEmpty from 'lodash/isEmpty';

import FallbackImg from '~/assets/images/cross-sell/Paper.jpg';

import { CrossSellCard } from './CrossSellCard';

import styles from './crossSellPaper.module.less';

export const STD_HREF = '/wedding-planning/save-the-date/shop?multi_sample_mode=multisampleenabled';

export const CrossSellPaper = ({ handleClick }: { handleClick: () => void }) => {
  const { crossSellData } = useGetCrossSellData({ card_type: CARD_TYPES.std });

  const trackAndNavigate = () => {
    if (typeof handleClick === 'function') {
      handleClick();
    }
    window.location.href = STD_HREF;
  };

  const {
    image_url: imageUrl,
    sampleTemplates,
    suites,
    cardType,
    isMatchingTheme,
  } = crossSellData || {};

  const preview = (
    <div className={styles.previewWrapper}>
      <UniversalCrossSellPreview
        activeSuite={(suites || [])[0]}
        cardType={cardType}
        className={styles.universalCrossSellPreview}
        customPhotoUrl={imageUrl || _isEmpty(sampleTemplates) ? FallbackImg : imageUrl}
        customPreviewTemplates={(sampleTemplates || [])[0]}
        enableFrame
        isMatchingTheme={isMatchingTheme}
        onClick={trackAndNavigate}
        samplePreviewPropOverrides={{ className: styles.samplePreview }}
      />
    </div>
  );

  return (
    <CrossSellCard
      hed="While you’re here, start your save the dates"
      cta="Get free samples"
      href={STD_HREF}
      onClick={handleClick}
      preview={preview}
      className={styles.crossSellPaper}
    />
  );
};

export default CrossSellPaper;
